import { defineMessages } from 'react-intl';

export default defineMessages({
    label: {
        id: '_.modal.fallback_error.label',
        defaultMessage: 'Oops, it looks like something went wrong'
    },
    refresh: {
        id: '_.modal.fallback_error.refresh',
        defaultMessage: 'Refresh'
    }
});
